import noUiSlider from 'nouislider'
import wNumb from 'wnumb'
import isMobile from 'ismobilejs'

export default function initRangeSlider(el, page, eventListenersRemover) {
  const { dataset } = el
  const input = page.querySelector(`#${dataset.range || 'null'}`)
  const disable = !('notDisabled' in dataset)
  if (disable) {
    input.disabled = true
  }
  const edit = (value, num) => {
    if (num === +dataset.start && dataset.minPrefix) {
      return dataset.minPrefix + value
    }

    if (num === +dataset.max && dataset.maxSuffix) {
      return value + dataset.maxSuffix
    }

    return value
  }
  const undo = value => {
    if (value === dataset.start && dataset.minPrefix) {
      return value.replace(dataset.minPrefix)
    }

    if (value === dataset.max && dataset.maxSuffix) {
      return value.replace(dataset.maxSuffix)
    }

    return value
  }
  const format = wNumb({
    decimals: 0,
    suffix: dataset.suffix,
    edit,
    undo,
  })
  const pipsFormat = wNumb({
    decimals: 0,
    suffix: dataset.suffix ? dataset.suffix : undefined,
    prefix: dataset.prefix ? dataset.prefix : undefined,
    edit,
  })
  let options = {
    animate: true,
    step: 1,
    range: {
      min: +dataset.min,
      max: +dataset.max,
    },
    pips: {
      mode: 'positions',
      values: dataset.minPips ? [0, 100] : [0, 50, 100],
      density: 100,
      format: pipsFormat,
    },
    format,
    tooltips: true,
  }

  if (dataset.type === 'single') {
    options = {
      ...options,
      ...{
        connect: 'lower',
        start: +dataset.start,
      },
    }
  }

  if (dataset.type === 'multiple') {
    options = {
      ...options,
      ...{
        connect: true,
        start: [+dataset.start, +dataset.next],
      },
    }
  }

  if (el.hasAttribute('data-pips-count')) {
    options = {
      ...options,
      ...{
        pips: {
          mode: 'positions',
          values: Array.from({ length: +dataset.pipsCount }).map(
            (_, i) => (i + 1) * +dataset.pipsCount
          ),
          density: 100,
          format: pipsFormat,
        },
      },
    }

    if (isMobile(window.navigator).any) {
      options = {
        ...options,
        ...{
          pips: {
            mode: 'count',
            values: 3,
            density: 100,
            format: pipsFormat,
          },
        },
      }
    }
  }

  // there are bugs if dataset.start !== dataset.min
  // use data-default-value if you want slider to start not from mimimal position
  if ('defaultValue' in dataset) {
    options.start = +dataset.defaultValue
  }

  noUiSlider.create(el, options)

  el.noUiSlider.on('change', (values, handle) => {
    if (disable) {
      input.disabled = false
    }
    if (format.from(values[handle]) < +dataset.start) {
      el.noUiSlider.set(+dataset.start)
    } else if (format.from(values[handle]) > +dataset.end) {
      el.noUiSlider.set(+dataset.end)
    }
  })

  const urlParams = new URLSearchParams(window.location.search)

  if (dataset.type === 'multiple' && urlParams.has(dataset.range)) {
    el.noUiSlider.set(
      urlParams
        .get(dataset.range)
        .split(' - ')
        .map((value, index) => (index === 0 ? +value : format.from(value)))
    )
  } else if (dataset.type === 'single' && urlParams.has(dataset.range)) {
    el.noUiSlider.set(format.from(urlParams.get(dataset.range)))
  }

  const resetRange = () => el.noUiSlider.reset()

  window.addEventListener('formReset', resetRange)

  if (input) {
    let isFirstTime = true
    el.noUiSlider.on('update', (values, handle) => {
      if ('skipFirst' in dataset && isFirstTime) {
        isFirstTime = false
        return
      }
      if (dataset.type === 'multiple') {
        input.value = `${format.from(values[0])} - ${format.from(values[1])} ${
          dataset.suffix
        }`
      } else {
        input.value = values[handle]
      }
      input.dispatchEvent(new Event('input'))
    })

    input.addEventListener('change', e => {
      format.from(e.target.value)
      if (format.from(e.target.value) < +dataset.start) {
        el.noUiSlider.set([+dataset.start])
      } else if (format.from(e.target.value) > +dataset.end) {
        el.noUiSlider.set([+dataset.end])
      } else {
        el.noUiSlider.set([e.target.value])
      }
    })
  }

  eventListenersRemover.push({
    el: window,
    event: 'resize',
    func: resetRange,
  })
}
